import { render, staticRenderFns } from "./bindwxUser.vue?vue&type=template&id=7e477b48&"
import script from "./bindwxUser.vue?vue&type=script&lang=js&"
export * from "./bindwxUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports